<template>
<body style="background-color:#e6f0f5;">
  <fy-form
    :model="travel_person_update_info"
    :rules="rules"
    class="fy-form-travel_person_update"
    ref="form"
    v-if="!isInit && !isInit1"
  >
    <div class="travel_person_update">
      <fy-form-item :label="fields.name.field_name" :prop="fields.name.field_enname">
        <fy-input
          :placeholder="fields.name.field_placeholder"
          type="text"
          v-model.trim="travel_person_update_info.name"
        ></fy-input>
        <div class="and_contacts">
          <span @click="same" v-bind:class="{same_cls: travel_person_update_info.is_same}">
            <img
              src="@/assets/images/html/blue_draw_03.png"
              v-show="travel_person_update_info.is_same"
            >
          </span>
          <i>同联系人</i>
        </div>
      </fy-form-item>
      <div class="travel_person_update_line">
        <div class="travel_person_left">
          <em>*</em>
          <i>性别</i>
        </div>
        <div class="travel_person_right travel_person_gender">
          <span>
            <div @click="travel_person_update_info.sex='男'">
              <i v-bind:class="{sex_cls: travel_person_update_info.sex=='男'}"></i>
            </div>
            <em>男</em>
          </span>
          <span>
            <div @click="travel_person_update_info.sex='女'">
              <i v-bind:class="{sex_cls: travel_person_update_info.sex=='女'}"></i>
            </div>
            <em>女</em>
          </span>
        </div>
      </div>
      <fy-form-item :label="fields.sex.field_name" :prop="fields.sex.field_enname" v-show="false">
        <fy-input
          :placeholder="fields.sex.field_placeholder"
          type="text"
          v-model="travel_person_update_info.sex"
        ></fy-input>
      </fy-form-item>
      <div class="travel_person_update_line travel_person_nationality">
        <div class="travel_person_left">
          <em>*</em>
          <i>国籍</i>
        </div>
        <select style="margin-top: 0;" v-model.trim="travel_person_update_info.nationality">
          <option value="中国大陆">中国大陆</option>
          <option value="中国香港">中国香港</option>
          <option value="中国澳门">中国澳门</option>
          <option value="中国台湾">中国台湾</option>
          <option value>其他</option>
        </select>
        <div class="travel_person_update_lineimg">
          <img alt src="@/assets/images/customer/bottomarrow3_03.png">
        </div>
      </div>
      <fy-form-item
        :label="fields.nationality2.field_name"
        :prop="fields.nationality2.field_enname"
        v-if="!travel_person_update_info.nationality"
      >
        <fy-input
          :placeholder="fields.nationality2.field_placeholder"
          type="text"
          v-model="travel_person_update_info.nationality2"
        ></fy-input>
      </fy-form-item>
      <!--       
      <div class="travel_person_update_line">
        <div class="travel_person_left">
          <em>*</em>
          <i>所属类型</i>
        </div>
        <select style="margin-top: 0;" v-model.trim="travel_person_update_info.person_type">
          <option v-for="option in person_type_list" :value="option.category_code">
            {{option.category}}
          </option>
        </select>
        <div class="travel_person_update_lineimg"><img src="@/assets/images/customer/bottomarrow3_03.png" alt=""></div>
      </div> 
      -->
      <fy-form-item :label="fields.person_type.field_name" :prop="fields.person_type.field_enname">
        <fy-select
          :options="person_type_list"
          labelKey="category"
          v-model="travel_person_update_info.person_type"
          valueKey="category_code"
        ></fy-select>
        <div class="travel_person_update_lineimg arrow">
          <img alt src="@/assets/images/customer/bottomarrow3_03.png">
        </div>
      </fy-form-item>

      <transition>
        <div class="travel_person_hidden" v-show="is_expansion">
          <div v-for="(column, index) in name_ist_columns" v-if="name_ist_columns.length > 0">
            <div class="travel_person_update_line" v-if="'credentials_type'==column.column_enname">
              <!-- 国内证件 -->
              <div class="travel_person_left">
                <i>证件类型</i>
              </div>
              <select
                style=" margin-top: 0;"
                v-model.trim="travel_person_update_info.credentials_type"
              >
                <option value>请选择</option>
                <option
                  :value="option.category_code"
                  v-for="option in credentials_type_list"
                >{{option.category}}</option>
              </select>
              <div class="travel_person_update_lineimg">
                <img alt src="@/assets/images/customer/bottomarrow3_03.png">
              </div>
            </div>

            <div class="travel_person_update_line" v-else-if="'id_card_no'==column.column_enname">
              <!-- 证件号 -->
              <div class="travel_person_left">
                <i>证件号</i>
              </div>
              <input
                name="id_card_no"
                placeholder="请输入正确的证件号码"
                type="text"
                v-model.trim="travel_person_update_info.id_card_no"
              >
            </div>

            <div v-else-if="'visa_type'==column.column_enname">
              <div class="travel_person_update_line">
                <!-- 是否已有签证 -->
                <div class="travel_person_left">
                  <i>是否已有签证</i>
                </div>
                <div class="travel_person_right travel_person_visa">
                  <span>
                    <div @click="travel_person_update_info.is_have_visa='有'">
                      <i
                        v-bind:class="{is_have_visa_cls: travel_person_update_info.is_have_visa=='有'}"
                      ></i>
                    </div>
                    <em>有</em>
                  </span>
                  <span>
                    <div @click="travel_person_update_info.is_have_visa='无'">
                      <i
                        v-bind:class="{is_have_visa_cls: travel_person_update_info.is_have_visa=='无'}"
                      ></i>
                    </div>
                    <em>无</em>
                  </span>
                </div>
              </div>
              <div
                class="travel_person_update_line travel_person_update_visa"
                v-show="travel_person_update_info.is_have_visa=='有'"
              >
                <div class="travel_person_left">&nbsp;</div>
                <input
                  id="visa"
                  name="visa_type"
                  placeholder="护照有效期须6个月以上"
                  type="text"
                  v-model.trim="travel_person_update_info.visa_type"
                >
              </div>
            </div>

            <div
              class="travel_person_update_line"
              v-else-if="'visa_date_of_expiry'==column.column_enname"
            >
              <!-- 签证有效期 -->
              <div class="travel_person_left">
                <i>签证有效期</i>
              </div>
              <input
                id="id_depart_time5"
                name="visa_date_of_expiry"
                placeholder="请选择"
                type="text"
                v-model.trim="travel_person_update_info.visa_date_of_expiry"
              >
              <div class="travel_person_update_lineimg travel_person_update_imgdate">
                <img alt id="id_depart_time5-img" src="@/assets/images/html/date_point_03.png">
              </div>
            </div>

            <div class="travel_person_update_line" v-else-if="'where_visa'==column.column_enname">
              <!-- 签证签发地 -->
              <div class="travel_person_left">
                <i>签证签发地</i>
              </div>
              <input
                name="where_visa"
                placeholder="请输入"
                type="text"
                v-model.trim="travel_person_update_info.where_visa"
              >
            </div>

            <div
              class="travel_person_update_line"
              v-else-if="'visa_date_of_issue'==column.column_enname"
            >
              <!-- 签证签发日期 -->
              <div class="travel_person_left">
                <i>签证签发日期</i>
              </div>
              <input
                id="id_depart_time4"
                name="visa_date_of_issue"
                placeholder="请选择"
                type="text"
                v-model.trim="travel_person_update_info.visa_date_of_issue"
              >
              <div class="travel_person_update_lineimg travel_person_update_imgdate">
                <img alt id="id_depart_time4-img" src="@/assets/images/html/date_point_03.png">
              </div>
            </div>

            <div
              class="travel_person_update_line"
              v-else-if="'type_of_endorsement'==column.column_enname"
            >
              <!-- 签注类型 -->
              <div class="travel_person_left">
                <i>签注类型</i>
              </div>
              <select
                name="type_of_endorsement"
                style=" margin-top: 0;"
                v-model.trim="travel_person_update_info.type_of_endorsement"
              >
                <option value>请选择</option>
                <option
                  :value="option.category_code"
                  v-for="option in credentials_type_list"
                >{{option.category}}</option>
              </select>
              <div class="travel_person_update_lineimg">
                <img alt src="@/assets/images/customer/bottomarrow3_03.png">
              </div>
            </div>

            <div
              class="travel_person_update_line"
              v-else-if="'credentials_date_of_expiry'==column.column_enname"
            >
              <!-- 证件有效期-->
              <div class="travel_person_left">
                <i>证件有效期</i>
              </div>
              <input
                id="id_depart_time3"
                name="credentials_date_of_expiry"
                placeholder="请选择"
                type="text"
                v-model.trim="travel_person_update_info.credentials_date_of_expiry"
              >
              <div class="travel_person_update_lineimg travel_person_update_imgdate">
                <img alt id="id_depart_time3-img" src="@/assets/images/html/date_point_03.png">
              </div>
            </div>

            <div
              class="travel_person_update_line"
              v-else-if="'credentials_date_of_issue'==column.column_enname"
            >
              <!-- 证件签发日期-->
              <div class="travel_person_left">
                <i>证件签发日期</i>
              </div>
              <input
                id="id_depart_time2"
                name="credentials_date_of_issue"
                placeholder="请选择"
                type="text"
                v-model.trim="travel_person_update_info.credentials_date_of_issue"
              >
              <div class="travel_person_update_lineimg travel_person_update_imgdate">
                <img alt id="id_depart_time2-img" src="@/assets/images/html/date_point_03.png">
              </div>
            </div>

            <div
              class="travel_person_update_line"
              v-else-if="'where_credentials'==column.column_enname"
            >
              <!-- 证件签发地-->
              <div class="travel_person_left">
                <i>证件签发地</i>
              </div>
              <input
                name="where_credentials"
                placeholder="请输入"
                type="text"
                v-model.trim="travel_person_update_info.where_credentials"
              >
            </div>

            <div class="travel_person_update_line" v-else-if="'mobile_phone'==column.column_enname">
              <!-- 手机号码-->
              <div class="travel_person_left">
                <i>手机号码</i>
              </div>
              <input
                id="tel"
                name="mobile_phone"
                placeholder="请输入"
                type="text"
                v-model.trim="travel_person_update_info.mobile_phone"
              >
            </div>
            <div v-else-if="'en_name'==column.column_enname">
              <div class="travel_person_update_line">
                <!-- 拼音姓-->
                <div class="travel_person_left">
                  <i>拼音姓</i>
                </div>
                <input
                  name="py_surname"
                  placeholder="例：李，填LI"
                  type="text"
                  v-model.trim="travel_person_update_info.py_surname"
                >
              </div>
              <div class="travel_person_update_line">
                <!-- 拼音名-->
                <div class="travel_person_left">
                  <i>拼音名</i>
                </div>
                <input
                  name="py_lastname"
                  placeholder="例：明，填Ming"
                  type="text"
                  v-model.trim="travel_person_update_info.py_lastname"
                >
              </div>
            </div>

            <div class="travel_person_update_line" v-else-if="'birthday'==column.column_enname">
              <!-- 出生日期-->
              <div class="travel_person_left">
                <i>出生日期</i>
              </div>
              <div class="travel_person_date">
                <!-- <fy-mobile-date v-model="travel_person_update_info.birthday"
                                  :start_date="calendar.start_date_birthday"
                                  :end_date="calendar.end_date_birthday"
                placeholder="请选择"></fy-mobile-date>-->
                <fy-el-date
                  :end_date="calendar.end_date_birthday"
                  :start_date="calendar.start_date_birthday"
                  v-model="travel_person_update_info.birthday"
                ></fy-el-date>
              </div>
              <!-- <fy-input-date type="text" placeholder="请选择" :calendar_prop="calendar"></fy-input-date> -->
              <!-- <input type="text" name="birthday" placeholder="请选择" v-model.trim="travel_person_update_info.birthday" id="id_depart_time1">
              <div class="travel_person_update_lineimg travel_person_update_imgdate">
                <img src="@/assets/images/html/date_point_03.png" alt="" id="id_depart_time1-img">
              </div>-->
            </div>

            <div class="travel_person_update_line" v-else-if="'contact_tel'==column.column_enname">
              <div class="travel_person_left">
                <i>电话</i>
              </div>
              <input
                id="contact_tel"
                name="contact_tel"
                placeholder="请输入"
                type="text"
                v-model.trim="travel_person_update_info.contact_tel"
              >
            </div>
            <div class="travel_person_update_line" v-else-if="'passport_no'==column.column_enname">
              <div class="travel_person_left">
                <i>护照号</i>
              </div>
              <input
                id="passport_no"
                name="passport_no"
                placeholder="请输入"
                type="text"
                v-model.trim="travel_person_update_info.passport_no"
              >
            </div>
            <div
              class="travel_person_update_line"
              v-else-if="'passport_where_visa'==column.column_enname"
            >
              <div class="travel_person_left">
                <i>护照签发地</i>
              </div>
              <input
                id="passport_where_visa"
                name="passport_where_visa"
                placeholder="请输入"
                type="text"
                v-model.trim="travel_person_update_info.passport_where_visa"
              >
            </div>
            <div
              class="travel_person_update_line"
              v-else-if="'passport_date_of_issue'==column.column_enname"
            >
              <div class="travel_person_left">
                <i>护照签发日期</i>
              </div>
              <div class="travel_person_date">
                <!-- <fy-mobile-date v-model="travel_person_update_info.passport_date_of_issue"
                                  :start_date="calendar.start_date_passport_date_of_issue"
                                  :end_date="calendar.end_date_passport_date_of_issue"
                placeholder="请选择"></fy-mobile-date>-->
                <fy-el-date
                  :end_date="calendar.end_date_passport_date_of_issue"
                  :start_date="calendar.start_date_passport_date_of_issue"
                  v-model="travel_person_update_info.passport_date_of_issue"
                ></fy-el-date>
              </div>
            </div>
            <div
              class="travel_person_update_line"
              v-else-if="'passport_date_of_expiry'==column.column_enname"
            >
              <div class="travel_person_left">
                <i>护照有效期</i>
              </div>
              <div class="travel_person_date">
                <!-- <fy-mobile-date v-model="travel_person_update_info.passport_date_of_expiry"
                                  :start_date="calendar.start_date_passport_date_of_expiry"
                                  :end_date="calendar.end_date_passport_date_of_expiry"
                placeholder="请选择"></fy-mobile-date>-->
                <fy-el-date
                  :end_date="calendar.end_date_passport_date_of_expiry"
                  :start_date="calendar.start_date_passport_date_of_expiry"
                  v-model="travel_person_update_info.passport_date_of_expiry"
                ></fy-el-date>
              </div>
            </div>
            <div class="travel_person_update_line" v-else-if="'birthplace'==column.column_enname">
              <div class="travel_person_left">
                <i>出生地</i>
              </div>
              <input
                id="birthplace"
                name="birthplace"
                placeholder="请输入"
                type="text"
                v-model.trim="travel_person_update_info.birthplace"
              >
            </div>
            <div class="travel_person_update_line" v-else-if="'age'==column.column_enname">
              <div class="travel_person_left">
                <i>年龄</i>
              </div>
              <input
                id="age"
                name="age"
                placeholder="请输入"
                type="text"
                v-model.trim="travel_person_update_info.age"
              >
            </div>
            <div class="travel_person_update_line" v-else-if="'rendezvous'==column.column_enname">
              <div class="travel_person_left">
                <i>集合点</i>
              </div>
              <input
                id="rendezvous"
                name="rendezvous"
                placeholder="请输入"
                type="text"
                v-model.trim="travel_person_update_info.rendezvous"
              >
            </div>
            <div class="travel_person_update_line" v-else-if="'sales_dept'==column.column_enname">
              <div class="travel_person_left">
                <i>营业点</i>
              </div>
              <input
                id="sales_dept"
                name="sales_dept"
                placeholder="请输入"
                type="text"
                v-model.trim="travel_person_update_info.sales_dept"
              >
            </div>
            <div class="travel_person_update_line" v-else-if="'room_no'==column.column_enname">
              <div class="travel_person_left">
                <i>房号</i>
              </div>
              <input
                id="room_no"
                name="room_no"
                placeholder="请输入"
                type="text"
                v-model.trim="travel_person_update_info.room_no"
              >
            </div>
            <div class="travel_person_update_line" v-else-if="'remark'==column.column_enname">
              <div class="travel_person_left">
                <i>备注</i>
              </div>
              <input
                id="remark"
                name="remark"
                placeholder="请输入"
                type="text"
                v-model.trim="travel_person_update_info.remark"
              >
            </div>

            <div
              class="travel_person_update_line"
              v-else-if="'hk_passport_no'==column.column_enname"
            >
              <div class="travel_person_left">
                <i>港澳通行证号</i>
              </div>
              <input
                id="hk_passport_no"
                name="hk_passport_no"
                placeholder="请输入"
                type="text"
                v-model.trim="travel_person_update_info.hk_passport_no"
              >
            </div>
            <div
              class="travel_person_update_line"
              v-else-if="'hk_passport_where_visa'==column.column_enname"
            >
              <div class="travel_person_left">
                <i>港澳通行证签发地</i>
              </div>
              <input
                id="hk_passport_where_visa"
                name="hk_passport_where_visa"
                placeholder="请输入"
                type="text"
                v-model.trim="travel_person_update_info.hk_passport_where_visa"
              >
            </div>
            <div
              class="travel_person_update_line"
              v-else-if="'tw_passport_no'==column.column_enname"
            >
              <div class="travel_person_left">
                <i>台湾通行证号</i>
              </div>
              <input
                id="tw_passport_no"
                name="tw_passport_no"
                placeholder="请输入"
                type="text"
                v-model.trim="travel_person_update_info.tw_passport_no"
              >
            </div>
            <div
              class="travel_person_update_line"
              v-else-if="'tw_passport_where_visa'==column.column_enname"
            >
              <div class="travel_person_left">
                <i>台湾通行证签发地</i>
              </div>
              <input
                id="tw_passport_where_visa"
                name="tw_passport_where_visa"
                placeholder="请输入"
                type="text"
                v-model.trim="travel_person_update_info.tw_passport_where_visa"
              >
            </div>
            <div
              class="travel_person_update_line"
              v-else-if="'hk_passport_date_of_issue'==column.column_enname"
            >
              <div class="travel_person_left">
                <i>港澳通行证签发日期</i>
              </div>
              <div class="travel_person_date">
                <!-- <fy-mobile-date v-model="travel_person_update_info.hk_passport_date_of_issue"
                                  :start_date="calendar.start_date_hk_passport_date_of_issue"
                                  :end_date="calendar.end_date_hk_passport_date_of_issue"
                placeholder="请选择"></fy-mobile-date>-->
                <fy-el-date
                  :end_date="calendar.end_date_hk_passport_date_of_issue"
                  :start_date="calendar.start_date_hk_passport_date_of_issue"
                  v-model="travel_person_update_info.hk_passport_date_of_issue"
                ></fy-el-date>
              </div>
            </div>
            <div
              class="travel_person_update_line"
              v-else-if="'hk_passport_date_of_expiry'==column.column_enname"
            >
              <div class="travel_person_left">
                <i>港澳通行证有效期</i>
              </div>
              <div class="travel_person_date">
                <!-- <fy-mobile-date v-model="travel_person_update_info.hk_passport_date_of_expiry"
                                  :start_date="calendar.start_date_hk_passport_date_of_expiry"
                                  :end_date="calendar.end_date_hk_passport_date_of_expiry"
                placeholder="请选择"></fy-mobile-date>-->
                <fy-el-date
                  :end_date="calendar.end_date_hk_passport_date_of_expiry"
                  :start_date="calendar.start_date_hk_passport_date_of_expiry"
                  v-model="travel_person_update_info.hk_passport_date_of_expiry"
                ></fy-el-date>
              </div>
            </div>
            <div
              class="travel_person_update_line"
              v-else-if="'tw_passport_date_of_issue'==column.column_enname"
            >
              <div class="travel_person_left">
                <i>台湾通行证签发日期</i>
              </div>
              <div class="travel_person_date">
                <!-- <fy-mobile-date v-model="travel_person_update_info.tw_passport_date_of_issue"
                                  :start_date="calendar.start_date_tw_passport_date_of_issue"
                                  :end_date="calendar.end_date_tw_passport_date_of_issue"
                placeholder="请选择"></fy-mobile-date>-->
                <fy-el-date
                  :end_date="calendar.end_date_tw_passport_date_of_issue"
                  :start_date="calendar.start_date_tw_passport_date_of_issue"
                  v-model="travel_person_update_info.tw_passport_date_of_issue"
                ></fy-el-date>
              </div>
            </div>
            <div
              class="travel_person_update_line"
              v-else-if="'tw_passport_date_of_expiry'==column.column_enname"
            >
              <div class="travel_person_left">
                <i>台湾通行证有效期</i>
              </div>
              <div class="travel_person_date">
                <!-- <fy-mobile-date v-model="travel_person_update_info.tw_passport_date_of_expiry"
                                  :start_date="calendar.start_date_tw_passport_date_of_expiry"
                                  :end_date="calendar.end_date_tw_passport_date_of_expiry"
                placeholder="请选择"></fy-mobile-date>-->
                <fy-el-date
                  :end_date="calendar.end_date_tw_passport_date_of_expiry"
                  :start_date="calendar.start_date_tw_passport_date_of_expiry"
                  v-model="travel_person_update_info.tw_passport_date_of_expiry"
                ></fy-el-date>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div
        @click="is_expansion=!is_expansion"
        class="travel_person_update_line travel_person_block"
      >
        <span>点击查看全部</span>
        <img alt src="@/assets/images/html/all_03.png" v-show="!is_expansion">
        <img alt src="@/assets/images/html/all_04.png" v-show="is_expansion">
      </div>
      <div class="teavel_person_submit teavel_person_update">
        <input @click="save" name="hold" type="button" value="保存">
      </div>
    </div>
  </fy-form>
</body>
</template>
<script>
import { FyInputDate } from "@/components/form"
import Vue from 'vue'
export default {
  name: 'TravelPersonUpdate',
  componentName: 'TravelPersonUpdate',
  data () {
    return {
      isInit: true, //判断页面初始化时的异步加载是否完成（由于父子组件间异步传数据，有可能子组件mounted阶段时异步加载还未完成）
      isInit1: true,
      fields: {},
      rules: {},
      orderInfo: {},
      plan_info: {},
      is_visa: true,
      type_name: '出行人',
      is_expansion: false,
      is_add: true,
      credentials_type_list: [],
      type_of_endorsement_list: [],
      person_type_list: [],
      name_ist_columns: [],
      travel_person_update_info: {
        name: '',
        sex: '',
        is_have_visa: '',
        member_types: 6,
        nationality: '中国大陆',
        nationality2: '',
        who_add: this.$sessionStorageUtil.get('member_id'),
        is_same: false,
        mobile_phone: '',
        id_card_no: '',
        person_type: '',
        credentials_type: '',
        type_of_endorsement: '',
        birthday: 0,
        contact_tel: '',
        passport_no: '',
        passport_where_visa: '',
        passport_date_of_issue: 0,
        passport_date_of_expiry: 0,
        birthplace: '',
        age: '',
        rendezvous: '',
        sales_dept: '',
        remark: '',
        hk_passport_no: '',
        hk_passport_where_visa: '',
        tw_passport_no: '',
        tw_passport_where_visa: '',
        hk_passport_date_of_issue: 0,
        hk_passport_date_of_expiry: 0,
        tw_passport_date_of_issue: 0,
        tw_passport_date_of_expiry: 0,
      },
      calendar: {
        start_date_birthday: this.$dateUtil.getNowDateAfterOrBeforeYearTimestamp(-100),
        end_date_birthday: new Date().getTime(),
        start_date_passport_date_of_issue: this.$dateUtil.getNowDateAfterOrBeforeYearTimestamp(-100),
        end_date_passport_date_of_issue: new Date().getTime(),
        start_date_passport_date_of_expiry: new Date().getTime(),
        end_date_passport_date_of_expiry: this.$dateUtil.getNowDateAfterOrBeforeYearTimestamp(50),

        start_date_hk_passport_date_of_issue: this.$dateUtil.getNowDateAfterOrBeforeYearTimestamp(-100),
        end_date_hk_passport_date_of_issue: new Date().getTime(),
        start_date_hk_passport_date_of_expiry: new Date().getTime(),
        end_date_hk_passport_date_of_expiry: this.$dateUtil.getNowDateAfterOrBeforeYearTimestamp(50),
        start_date_tw_passport_date_of_issue: this.$dateUtil.getNowDateAfterOrBeforeYearTimestamp(-100),
        end_date_tw_passport_date_of_issue: new Date().getTime(),
        start_date_tw_passport_date_of_expiry: new Date().getTime(),
        end_date_tw_passport_date_of_expiry: this.$dateUtil.getNowDateAfterOrBeforeYearTimestamp(50),
      },
    }
  },
  props: {
    order_contract_info: Object,
    order_add_info: Object,
    travel_person_id: {
      type: Number,
      defalut: 0
    }
  },
  created () {
    this.$pageField.init(this, 'fields', 'travelPersonUpdate').then(res => {
      this.isInit1 = false
      console.log(res)
    })
    this.init()
  },
  methods: {
    init () {
      const plan_info = this.$sessionStorageUtil.get('route_order_plan_info')
      if (plan_info) {
        this.plan_info = plan_info
      }
      if (this.travel_person_id && this.travel_person_id != 0) {
        this.is_add = false
      }
      var params = {
        memberId: this.travel_person_id,
        routePlanId: this.plan_info.route_plan_id,
        routePlanSource: this.plan_info.source
      }
      this.$myGet('order_info/travel_person_update', params).then(res => {
        const rcode = res.response.data.rcode
        console.log(rcode)
        if (rcode == 0) {
          if (!this.is_add) {
            this.travel_person_update_info = res.response.data.member
          }
          this.dateTypePaser()
          Vue.set(this.travel_person_update_info, 'is_have_visa', '')
          var enName = this.travel_person_update_info.en_name
          if (enName) {
            this.travel_person_update_info.py_surname = enName.substring(0, enName.indexOf(","))
            this.travel_person_update_info.py_lastname = enName.substring(enName.indexOf(",") + 1)
          }
          var nation = this.travel_person_update_info.nationality
          if (nation != "中国大陆" && nation != "中国香港" && nation != "中国澳门" && nation != "中国台湾" && nation != "") {
            this.travel_person_update_info.nationality2 = nation
            this.travel_person_update_info.nationality = ''
          }
          this.credentials_type_list = res.response.data.credentials_type_list
          this.type_of_endorsement_list = res.response.data.type_of_endorsement_list
          this.person_type_list = res.response.data.person_type_list
          this.name_ist_columns = res.response.data.name_ist_columns
          this.isInit = false
        }
      })
        .catch(err => {
          console.log('err:' + err)
        })
    },
    save () {
      this.$refs.form.validate((valid, invalidFields) => {
        if (valid) {
          this.dataPaser()

          var orderAddInfo = this.order_add_info
          if (orderAddInfo.temp_member_id != null) {
            this.travel_person_update_info.who_add = orderAddInfo.temp_member_id
          }
          if (this.is_add) {
            this.$myPost('member/add_travel_person', this.travel_person_update_info).then(res => {
              const rcode = res.response.data.rcode
              if (rcode == 0) {
                this.$msg('保存成功', 'success', 3000);
                this.$domUtils.dispatch(this, 'TravelPerson', 'cut.travel.person', { show_often: true })
              }
            })
          } else {
            this.$myPut('member', this.travel_person_update_info).then(res => {
              const rcode = res.response.data.rcode
              if (rcode == 0) {
                this.$msg('保存成功', 'success', 3000);
                this.$domUtils.dispatch(this, 'TravelPerson', 'cut.travel.person', { show_often: true })
              }
            })
          }
        } else {
          this.$msg(invalidFields[0].message, 'info', 3000);
        }
      })
    },
    dateTypePaser () {
      if (this.travel_person_update_info.birthday == null) {
        this.travel_person_update_info.birthday = 0
      }
      if (this.travel_person_update_info.passport_date_of_issue == null) {
        this.travel_person_update_info.passport_date_of_issue = 0
      }
      if (this.travel_person_update_info.passport_date_of_expiry == null) {
        this.travel_person_update_info.passport_date_of_expiry = 0
      }
      if (this.travel_person_update_info.hk_passport_date_of_issue == null) {
        this.travel_person_update_info.hk_passport_date_of_issue = 0
      }
      if (this.travel_person_update_info.hk_passport_date_of_expiry == null) {
        this.travel_person_update_info.hk_passport_date_of_expiry = 0
      }
      if (this.travel_person_update_info.tw_passport_date_of_issue == null) {
        this.travel_person_update_info.tw_passport_date_of_issue = 0
      }
      if (this.travel_person_update_info.tw_passport_date_of_expiry == null) {
        this.travel_person_update_info.tw_passport_date_of_expiry = 0
      }
    },
    dataPaser () {
      if (this.travel_person_update_info.py_surname || this.travel_person_update_info.py_lastname) {
        this.travel_person_update_info.en_name = this.travel_person_update_info.py_surname + "," + this.travel_person_update_info.py_lastname
      }
      if (!this.travel_person_update_info.nationality) {
        this.travel_person_update_info.nationality = this.travel_person_update_info.nationality2
      }
      if (this.travel_person_update_info.birthday == 0) {
        this.$delete(this.travel_person_update_info, 'birthday')
      }
      if (this.travel_person_update_info.passport_date_of_issue == 0) {
        this.$delete(this.travel_person_update_info, 'passport_date_of_issue')
      }
      if (this.travel_person_update_info.passport_date_of_expiry == 0) {
        this.$delete(this.travel_person_update_info, 'passport_date_of_expiry')
      }
      if (this.travel_person_update_info.hk_passport_date_of_issue == 0) {
        this.$delete(this.travel_person_update_info, 'hk_passport_date_of_issue')
      }
      if (this.travel_person_update_info.hk_passport_date_of_expiry == 0) {
        this.$delete(this.travel_person_update_info, 'hk_passport_date_of_expiry')
      }
      if (this.travel_person_update_info.tw_passport_date_of_issue == 0) {
        this.$delete(this.travel_person_update_info, 'tw_passport_date_of_issue')
      }
      if (this.travel_person_update_info.tw_passport_date_of_expiry == 0) {
        this.$delete(this.travel_person_update_info, 'tw_passport_date_of_expiry')
      }
    },
    sex (val) {
      this.travel_person_update_info.sex = val
    },
    same () {
      this.travel_person_update_info.is_same = !this.travel_person_update_info.is_same
      if (this.travel_person_update_info.is_same) {
        const route_order_contract_info = this.order_contract_info
        if (route_order_contract_info) {
          this.travel_person_update_info.name = route_order_contract_info.contact_person
          this.travel_person_update_info.mobile_phone = route_order_contract_info.contact_tel
        }
      } else {
        this.travel_person_update_info.name = ''
        this.travel_person_update_info.mobile_phone = ''
      }
    }
  }
}
</script>
<style scoped>
@import '../../../assets/css/pages/customer/second_phase.css';
.travel_person_gender span div i.sex_cls {
  display: block;
}
.travel_person_visa span div i.is_have_visa_cls {
  display: block;
}
.same_cls {
  border: 0.2em solid #0d9eff;
}
.travel_person_hidden.v-leave {
  opacity: 1;
}
.travel_person_hidden.v-leave-active {
  transition: all 0.8s;
}
.travel_person_hidden.v-leave-to {
  opacity: 0;
}
.travel_person_hidden.v-enter {
  opacity: 0;
}
.travel_person_hidden.v-enter-active {
  transition: all 0.8s;
}
.travel_person_hidden.v-enter-to {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/customer/travel_person/travelPersonUpdate.vue